import React, {useEffect} from 'react';
import {images} from '../../../../../assets/icons';
import {Props} from './model';
import {TouchableOpacity, View, StyleSheet} from 'react-native';
import {useStyles} from '../../../../../shared/hooks/styles';
import {Text} from '../../../../../shared/components/text';
import {useAccountLinker} from '../../../../../shared/hooks/useAccountLinkerHook/useAccountLinker';
import {AccordionDesktop} from '../nameInfoAccordionDesktop';
import {getTokenForLinkedAccount} from '../../../../../shared/hooks/useAccountLinkerHook/api';
import {useDispatch, useSelector} from 'react-redux';
import {holderProfileSelector} from '../../../../../redux/selectors/profile';
import {capitalizeLastWord} from '../../../../../shared/utils/text';

const NameCard = (props: {id?: number; fullName: string; isParentAccount?: boolean}) => {
  const {id, fullName} = props;
  const dispatch = useDispatch();
  const {switchToLinkedAccount, setParentAccount, parentAccount, linkedAccounts} = useAccountLinker();
  const profile = useSelector(holderProfileSelector());

  const styles = useStyles(({theme}) => ({
    menuElement: {
      backgroundColor: 'rgba (0, 0, 0)',
    },
    arrowColor: {
      color: theme.color.textColor,
    },
    arrow: {
      fontSize: 24,
      height: theme.fonts.h6Light.lineHeight,
    },
  }));

  const isLinkedAccountCardActivated = () => {
    if (id) return linkedAccounts.filter((acc) => acc.id === id && acc.cardStatusId === 2).length > 0;
    return true;
  };

  const handlePress = async () => {
    if (!isLinkedAccountCardActivated()) return;
    const tokenToReplace =
      props.isParentAccount && parentAccount?.token
        ? parentAccount.token // necessary to cover with quotes to be properly saved in storage
        : id
        ? (await getTokenForLinkedAccount(id.toString())).token
        : null;
    if (!tokenToReplace) return;

    if (!props.isParentAccount) await setParentAccount(profile?.displayName || 'Родительский профиль');
    switchToLinkedAccount(tokenToReplace, dispatch);
  };
  return (
    <TouchableOpacity
      testID={`profile-mobile-menu-item--link-id`}
      style={styles.menuElement}
      onPress={handlePress}
      accessibilityRole='link'>
      <View style={{display: 'flex', flexDirection: 'row', justifyContent: 'space-between', width: '100%'}}>
        <Text type='h6Light' style={{marginBottom: 15}}>
          {fullName}
        </Text>
        <View style={styles.arrow}>
          <images.Right width={24} height={24} color={StyleSheet.flatten(styles.arrowColor).color} />
        </View>
      </View>
    </TouchableOpacity>
  );
};

export default (props: Props) => {
  const {name} = props;

  const {linkedAccounts, parentAccount, getParentAccount} = useAccountLinker();

  useEffect(() => {
    getParentAccount();
  }, []);

  const accountsToList = linkedAccounts.filter(
    (account) => account.isCardHolderParent === false && account.status === 'Accepted',
  );
  return (
    <>
      {accountsToList.length !== 0 || parentAccount != null ? (
        <AccordionDesktop title={name} index={1}>
          <View testID='profile-menu-id' style={{width: '100%', display: 'flex', marginTop: 0, flex: 1}}>
            {parentAccount != null && (
              <NameCard fullName={capitalizeLastWord(parentAccount.fullName)} isParentAccount />
            )}
            {accountsToList.map((account, index) => {
              return (
                <NameCard fullName={capitalizeLastWord(account.counterpartyFullName)} id={account.id} key={index} />
              );
            })}
          </View>
        </AccordionDesktop>
      ) : (
        <Text type='h6Light'>{name}</Text>
      )}
    </>
  );
};
